import type { BalancesRepositoryT } from "../../domain/ports/balances.repostory";

type GetBalancesParamsT = {
  typeId?: string;
  balancesRepository: BalancesRepositoryT;
  colaboraInstanceId: string;
  page?: number;
  pageSize?: number;
};

export const getBalances = async ({
  typeId,
  balancesRepository,
  colaboraInstanceId,
  page,
  pageSize,
}: GetBalancesParamsT) =>
  balancesRepository.getAll({
    typeId,
    colaboraInstanceId,
    page,
    pageSize,
  });
